import { Injectable } from "@angular/core";
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { SingUpRequest } from "../../domain/model/account.model";
import { AccountFacade } from "../../domain/+state/account.facade";
import { MessageService, OAuthService } from "common";
import { SignUpForm } from "./sign-up.model";
import { FormGroup } from "@angular/forms";
import { getSignUpFormGroup } from "./sign-up.data";

@UntilDestroy()
@Injectable()
export class SignUpFacade {

  constructor(
    private readonly accountFacade: AccountFacade,
    private readonly messageService: MessageService,
    private readonly oauthService: OAuthService
  ) { }

  signUp(form: any): void {
    this.accountFacade
      .signUp(form)
      .pipe(untilDestroyed(this))
      .subscribe({
      next: () => this.signUpSuccess(form),
      error: this.signUpError.bind(this),
    });
  }

  private signUpError(response: any): void {
      this.messageService.error(response);
  }

  private signUpSuccess(request: SingUpRequest): void {
    this.oauthService.sessionEndLocal();
    this.accountFacade
      .signInByPassword(request.email, request.password, false)
      .pipe(untilDestroyed(this))
      .subscribe();
  }

  initForm(): FormGroup<SignUpForm> {
    const form = getSignUpFormGroup();
    form.controls.email.disable();
    return form;
  }
}
